export const ActionTypes = {
  UPDATE_REGISTRATION_TYPE: 'UPDATE_REGISTRATION_TYPE',
  TOGGLE_ADDON: 'TOGGLE_ADDON',
  REORDER_ADDONS: 'REORDER_ADDONS',
  ADD_ADDON: 'ADD_ADDON',
  UPDATE_ADDON: 'UPDATE_ADDON',
  DELETE_ADDON: 'DELETE_ADDON',
};

export const updateRegistrationType = (updatedData) => ({
  type: ActionTypes.UPDATE_REGISTRATION_TYPE,
  payload: updatedData,
});

export const toggleAddon = (id) => ({
  type: ActionTypes.TOGGLE_ADDON,
  payload: id,
});

export const reorderAddons = (reorderedAddons) => ({
  type: ActionTypes.REORDER_ADDONS,
  payload: reorderedAddons,
});

export const addAddon = (addon) => ({
  type: ActionTypes.ADD_ADDON,
  payload: {
    ...addon,
    id: `new_${Date.now()}`,
    active: true,
    count_used: 0,
    metadatum_id: addon.metadatum_id || ""
  },
});

export const updateAddon = (updatedAddon) => ({
  type: ActionTypes.UPDATE_ADDON,
  payload: updatedAddon,
});

export const deleteAddon = (id) => ({
  type: ActionTypes.DELETE_ADDON,
  payload: id,
});